export const standardReducer = {
  pending: (state, action) => {
    state.loading = true;
    state.errorMessage = '';
  },
  fulfilled: (state, action) => {
    state.loading = false;
    state.records = { ...state.records, ...action.payload };
  },
  rejected: (state, action) => {
    const { message } = action.error;
    state.errorMessage = message;
    state.loading = false;
  }
};